<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
>
    <v-select
        label="Sample Timeline"
        :items="sample_timelines"
        v-model="selected_timeline"
    />

    <v-timeline
        align-top
        dense
      >
        <m-timeline-event
            v-for="(item, index) in timeline"
            :key="'event_'+index"
            :value="item"
        />
      </v-timeline>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            selected_timeline: 'timeline_reservation',

            sample_timelines: [
                { 'text' : 'Reservation Timeline', 'value': 'timeline_reservation' },
                { 'text' : 'Order Fulfilled Timeline', 'value': 'timeline_fulfilled' },
                { 'text' : 'Collectors Club Customization Deadline', 'value': 'timeline_club_customization' },
            ],

            timeline_reservation: [
                {
                    event_type: 'offset',
                    time_desc: '4 Days Before',
                    time: '-4d',
                    actions: [
                        { 'action_type': 'email', 'label': 'Reservation Reminder: 4 Days Before', 'conditions': ['Has not opted-out of email','Reservation has not been cancelled'] },
                    ],
                },

                {
                    event_type: 'offset',
                    time_desc: '3 Days Before',
                    time: '-3d',
                    actions: [
                        { 'action_type': 'text', 'label': 'Reservation Reminder: 3 Days Before', 'conditions': ['Has mobile number','Has not opted-out of informational text messages','Reservation has not been cancelled','Did not click any link in email "Reservation Reminder: 4 Days Before"'] },
                    ],
                },

                {
                    event_type: 'offset',
                    time_desc: '1 Day Before',
                    time: '-1d',
                    actions: [
                        { 'action_type': 'email', 'label': 'Reservation Reminder: Day Before', 'conditions': ['Has not opted-out of email','Reservation has not been cancelled'] },
                    ],
                },

                {
                    event_type: 'offset',
                    time_desc: '8:00 AM Morning of Reservation',
                    time: '-1d',
                    actions: [
                        { 'action_type': 'email', 'label': 'Reservation Reminder: Today is the Day!', 'conditions': ['Has not opted-out of email','Reservation has not been cancelled'] },
                        { 'action_type': 'text', 'label': 'Reservation Reminder: Today is the Day!', 'conditions': ['Has mobile number','Has not opted-out of informational text messages','Reservation has not been cancelled','Has not clicked any email link', ] },
                        { 'action_type': 'webhook', 'label': 'https://www.your-pos.com/reservations/for-today', 'conditions': ['Reservation has not been cancelled'] },
                    ],
                    warn_multiple: true,
                },


                {
                    event_type: 'anchor',
                    time: '0',
                    time_desc: 'Reservation Start Time',
                    actions: [],
                },

                {
                    event_type: 'offset',
                    time_desc: '1 Day After',
                    time: '1d',
                    actions: [
                        { 'action_type': 'email', 'label': 'Thanks for Visiting Us! (+special offer)', 'conditions': ['Has not opted-out of email','Reservation has not been cancelled', 'Reservation was kept (i.e. not a no-show)'] },
                    ],
                },

                {
                    event_type: 'offset',
                    time_desc: '7 Days After',
                    time: '7d',
                    actions: [
                        { 'action_type': 'text', 'label': 'Special Offer, additional 20% off after visiting (club members only)', 'conditions': ['Has mobile number','Has not opted-out of promotinoal text messages','Reservation has not been cancelled','Reservation was kept (i.e. not a no-show)','No purchases since day of reservation', 'At least one active club membership', ] },
                        { 'action_type': 'text', 'label': 'Special Offer, 10% off first year of new club membership (non-club members)', 'conditions': ['Has mobile number','Has not opted-out of promotinoal text messages','Reservation has not been cancelled','Reservation was kept (i.e. not a no-show)','No club memberships', ] },
                    ],
                },
            ],

            timeline_fulfilled: [
                {
                    event_type: 'anchor',
                    time: '0',
                    time_desc: 'Order Fulfilled',
                    actions: [],
                },

                {
                    event_type: 'offset',
                    time_desc: '7 Days After',
                    time: '7d',
                    actions: [
                        { 'action_type': 'email', 'label': 'A/B Test: Tell Us How We Did!', 'conditions': ['Has not opted-out of email','A/B Test: Customer profile randomly assigned to group A'] },
                        { 'action_type': 'email', 'label': 'A/B Test: How Were Your First Sips?', 'conditions': ['Has not opted-out of email','A/B Test: Customer profile randomly assigned to group B'] },
                    ],
                },

                {
                    event_type: 'offset',
                    time_desc: '10 Days After',
                    time: '10d',
                    actions: [
                        { 'action_type': 'text', 'label': 'A/B Test: Tell Us How We Did!', 'conditions': ['Has mobile number','Has not opted-out of informational text messages', 'Has not opened email', 'A/B Test: Customer profile randomly assigned to group A'] },
                        { 'action_type': 'text', 'label': 'A/B Test: How Were Your First Sips?', 'conditions': ['Has mobile number','Has not opted-out of informational text messages', 'Has not opened email', 'A/B Test: Customer profile randomly assigned to group B'] },
                    ],
                },
            ],

            timeline_club_customization: [

                {
                    event_type: 'offset',
                    time_desc: '30 Days Before',
                    time: '-30d',
                    actions: [
                        { 'action_type': 'email', 'label': 'Collectors Club: Here Before You Know It (Customize Today!)', 'conditions': ['Has not opted-out of email','Has not customized club'] },
                    ],
                },

                {
                    event_type: 'offset',
                    time_desc: '15 Days Before',
                    time: '-15d',
                    actions: [
                        { 'action_type': 'email', 'label': 'Collectors Club: Lets Get Your Selections Locked In!', 'conditions': ['Has not opted-out of email','Has not customized club'] },
                    ],
                },

                {
                    event_type: 'offset',
                    time_desc: '10 Days Before',
                    time: '-10d',
                    actions: [
                        { 'action_type': 'email', 'label': 'Collectors Club: Special Offer For Customizing Early (10% off add ons!)', 'conditions': ['Has not opted-out of email','Has not customized club'] },
                    ],
                },

                {
                    event_type: 'offset',
                    time_desc: '3 Days Before',
                    time: '-3d',
                    actions: [
                        { 'action_type': 'text', 'label': 'Collectors Club: Time To Customize', 'conditions': ['Has mobile number','Has not opted-out of informational text messages','Has not customized club'] },
                        { 'action_type': 'email', 'label': 'Collectors Club: Time To Customize', 'conditions': ['Has not opted-out of email','Has not customized club', 'Has not received any other club customization text or email today'] },
                    ],
                },

                {
                    event_type: 'offset',
                    time_desc: '1 Day Before',
                    time: '-1d',
                    actions: [
                        { 'action_type': 'text', 'label': 'Collectors Club: Last Call! (To Customize)', 'conditions': ['Has mobile number','Has not opted-out of informational text messages','Has not customized club'] },
                        { 'action_type': 'email', 'label': 'Collectors Club: Last Call! (To Customize)', 'conditions': ['Has not opted-out of email','Has not customized club', 'Has not received any other club customization text or email today'] },
                    ],
                },

                {
                    event_type: 'anchor',
                    time: '0',
                    time_desc: 'Collectors Club Customization Deadline',
                    actions: [],
                },
            ],

            
        };
    },

    computed: {
            timeline() {
                return this[this.selected_timeline];
            },

            title() {
                return this.sample_timelines
                    .filter(el => el.value == this.selected_timeline)
                    .map(el => el.text);
            },
        },
}
</script>

<style lang="scss" scoped>
</style>